<script setup lang="ts">
// Migrated here from app/src/components/ui/UIHeading.vue. A temporary re-export shim
// remains at that path for back-compat; it can be removed once fieldkit-resdesign-2026 merges.
type UIHeadingVariant = keyof typeof variantMapping

const props = withDefaults(
  defineProps<{
    /** Which variant of the heading should be used? */
    variant?: UIHeadingVariant
    /** What HTML tag should be used to render the heading? */
    tag: string
    /** What text should be displayed?<br/>(Can also be provided via the slot.) */
    text?: string // optional alternative to using the <slot>
  }>(),
  {
    variant: 'serif'
  }
)

const serifNormal = 'font-serif font-normal'
const variantMapping = {
  serif: `${serifNormal} text-heading-serif`,
  'serif-3xl': `${serifNormal} text-heading-serif-3xl`,
  'serif-2xl': `${serifNormal} text-heading-serif-2xl`,
  'serif-xl': `${serifNormal} text-heading-serif-xl`,
  'serif-lg': `${serifNormal} text-heading-serif-lg`,
  'serif-sm': `${serifNormal} text-heading-serif-sm`,
  'serif-xs': `${serifNormal} text-heading-serif-xs`,
  sans: 'font-sans text-heading-sans',
  'sans-bold': 'font-sans font-bold text-heading-sans'
}
</script>
<template>
  <component
    :is="props.tag"
    :class="variantMapping[props.variant]"
    class="text-emphasis"
  >
    <!-- eslint-disable vue/no-v-html -->
    <slot v-if="!text" />
    <span v-if="text" v-html="text"></span>
  </component>
</template>
